
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkouts/[dispensaryId]/[checkoutId]",
      function () {
        return require("private-next-pages/checkouts/[dispensaryId]/[checkoutId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkouts/[dispensaryId]/[checkoutId]"])
      });
    }
  